import * as React from 'react'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { TextBlock } from '@amzn/dvui/dist/TextBlock'
import * as st from './notificationAction.module.scss'
import { ConditionalText } from '../../utils/conditionalText'
import * as hoverClasses from '../../widgets/Hover/hoverComponent.module.scss'

export interface ITextBlockNotificationProps {
  messages?: WpsRuntime.atv.wps.DVStringList
}

export const TextBlockNotification = ({ messages }: ITextBlockNotificationProps) => {
  if (!messages || !messages.length) {
    return null
  }
  // TODO: AVWebDetailPage-1831
  return (
    <>
      { messages.map((message, idx) => (
          <ConditionalText key={`text-block-conf-text-${idx}`} Tag={TextBlock} className={`${st.notificationBox} ${hoverClasses.buttonOverride}`} message={message} />
        ))}
    </>
  )
}
